export default __webpack_public_path__ + "static/media/push.a08e9d5f.svg";